<template>
  <div id="app" v-cloak>
    <spinner-loader></spinner-loader>
    <login-confirm v-if="$store.state.loggingIn"></login-confirm>
    <site-nav></site-nav>
    <router-view/>
    <site-footer></site-footer>
  </div>
</template>
<script>
import nav from '@/components/nav/nav.vue'
import footer from '@/components/footer/footer.vue'
import loginConfirm from '@/components/login-confirm/login-confirm.vue'
import spinner from '@/components/spinner/spinner.vue'

export default {
  name: 'app',
  data () {
    return {}
  },
  components: {
    'site-nav': nav,
    'site-footer': footer,
    'spinner-loader': spinner,
    'login-confirm': loginConfirm
  },
  mounted: function () {
    this.$store.state.authService.onAuthStateChanged(user => {
      this.$store.dispatch('currentUser', user);
    })
  },
  methods: {}
}
</script>

<style src="./styles/main.styl" lang="stylus"></style>
